import { Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import Button from '@components/atoms/button/button';
import clsx from 'clsx';
import { AllowedNegotiationActions } from '@interfaces/models/negotiation/negotiation';
import useWindowSize from '@hooks/use-window-size';
import styles from './status-action.module.scss';

export const StatusAction = ({
  nextActions,
  isNextActionsShown,
  setIsNextActionsShown,
  negotiation,
  negotiationProduct,
  isOrderButtonDisabled,
  acceptOffer,
  rejectOffer,
  selectAction,
  addToCart,
  isSingleBtn,
}) => {
  const { t } = useTranslation();
  const { isWiderThanMd } = useWindowSize();
  const { sendAnalyticEvent: sendNegotiationAnalyticEvents } = useAnalyticEvents('mmao');

  return (
    <>
      {!!nextActions.length && isNextActionsShown && (
        <div
          className={clsx(styles.mmao__action, isSingleBtn && styles.mmao__action__singleBtn)}
          data-cy="mmao_action"
        >
          {nextActions.map((action: AllowedNegotiationActions) => (
            <Fragment key={action}>
              {action === 'reject' && (
                <Button
                  variant={isSingleBtn ? 'primary' : 'secondary'}
                  size="medium"
                  className={styles.mmao__action__button}
                  onClick={() => rejectOffer()}
                >
                  {t('MMAO.CTA.REJECT_OFFER')}
                </Button>
              )}
              {action === 'offer' && (
                <Button
                  variant={isSingleBtn ? 'primary' : 'secondary'}
                  size="medium"
                  className={styles.mmao__action__button}
                  fullWidth={!isWiderThanMd}
                  onClick={() => {
                    selectAction(action);
                    setIsNextActionsShown(false);
                  }}
                >
                  {t('MMAO.CTA.MAKE_COUNTER_OFFER')}
                </Button>
              )}
              {action === 'accept' && (
                <Button
                  variant="primary"
                  size="medium"
                  className={styles.mmao__action__button}
                  onClick={() => acceptOffer()}
                >
                  {t('MMAO.CTA.ACCEPT_OFFER')}
                </Button>
              )}
              {action === 'order' && (
                <Button
                  variant="primary"
                  size="medium"
                  className={styles.mmao__action__button}
                  disabled={isOrderButtonDisabled}
                  onClick={() => {
                    sendNegotiationAnalyticEvents('mmao_add_to_bag', {
                      product_id: negotiationProduct.id,
                      seller_id: String(negotiationProduct.seller?.id || ''),
                      product_unit_price: String(negotiationProduct.price?.cents / 100),
                      product_ds_eligible: String(negotiationProduct.flags?.includes('direct-shipping')),
                      screen_subcategory: window.tc_vars.screen_subcategory,
                      screen_category: window.tc_vars.screen_category,
                      property: 'from_negotiating_area',
                    });
                    addToCart();
                  }}
                >
                  {negotiation.isAccepted && <span>{t('MMAO.ONGOING_BANNER_OFFER_BUY_NOW')}</span>}
                  {!negotiation.isAccepted && <span>{t('PRODUCT.DETAILS.CTA.BUY')}</span>}
                </Button>
              )}
            </Fragment>
          ))}
        </div>
      )}
    </>
  );
};
